import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Linkedin, Github, Download } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const SocialLinks = () => (
  <>
    {[
      { icon: Linkedin, url: "https://www.linkedin.com/in/jessile-joyce-bonzo/", label: "LinkedIn" },
      { icon: Github, url: "https://github.com/jessilebonzo", label: "GitHub" },
    ].map(({ icon: Icon, url, label }, index) => (
      <a 
        key={index}
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label={label}
      >
        <Icon className="w-8 h-8 text-secondary hover:text-secondary/80 transition-colors" />
      </a>
    ))}
  </>
);

const Home = () => {
  const [titleIndex, setTitleIndex] = useState(0);
  const [isImageClicked, setIsImageClicked] = useState(false);
  const titles = ["Software Engineer", "Full Stack Developer"];
  const { isDarkMode } = useTheme();
  
  useEffect(() => {
    const interval = setInterval(() => {
      setTitleIndex((prevIndex) => (prevIndex + 1) % titles.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, [titles.length]);

  const handleImageClick = () => {
    setIsImageClicked(!isImageClicked);
  };
    return (
      <section 
        id="home" 
        className={`flex flex-col md:flex-row justify-between items-center min-h-[75vh] md:min-h-[60vh] lg:min-h-[75vh] px-8 sm:px-10 md:px-16 lg:px-24 ${
          isDarkMode ? 'bg-primary text-white' : 'bg-gray-200 text-gray-800'
        } pt-6 md:pt-4 pb-6 md:pb-4 transition-colors duration-300`}
      >
        {/* The rest of your content */}
      <div className="max-w-xl mb-10 md:mb-0 text-left">
        <motion.h2 
          className={`text-2xl md:text-4xl font-bold text-left ${
            isDarkMode ? 'text-white' : 'text-gray-800'
          }`}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Hello, I'm Jessile Bonzo
        </motion.h2>
        <motion.h1
          className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-[#83329A] to-[#bd9fe6] text-transparent bg-clip-text mt-4 text-left"
          animate={{ opacity: [0, 1], y: [-10, 0] }}
          transition={{ duration: 0.5 }}
          key={titles[titleIndex]}
        >
          {titles[titleIndex]}
        </motion.h1>
        
        <motion.p 
          className={`mt-4 text-base md:text-lg ${
            isDarkMode ? 'text-tertiary' : 'text-gray-600'
          } text-left transition-colors duration-300`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
         Crafting AI-driven software solutions that leverage LLMs and modern technologies to create reliable, functional, and secure applications.
        </motion.p>

        <motion.div 
          className="mt-6 flex flex-col items-start gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <a
            href="https://drive.google.com/file/d/1HN85_FOEf_SGSTqTUIkpTuD_FkNl05FY/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-[#83329A] to-[#A988D8] text-white px-4 md:px-5 lg:px-6 py-2 rounded-full font-semibold shadow-md hover:opacity-80 transition-all flex items-center gap-1 md:gap-2 text-base md:text-base lg:text-lg w-fit"
          >
            <span className="whitespace-nowrap">Resume - Jessile Bonzo</span> <Download size={18} className="min-w-[18px]" />
          </a>
          <div className="flex gap-4 mt-2 justify-start w-full">
            <SocialLinks />
          </div>
        </motion.div>
      </div>
      <motion.div
        className="relative pr-4 md:pr-6 lg:pr-30 pt-2 pb-8 md:pt-3 md:pb-3 lg:pt-4 lg:pb-4"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div
          className={`relative rounded-full transition-all duration-300 ${
            isImageClicked
              ? "bg-gradient-to-r from-[#83329A] to-[#A988D8] p-3 inline-block shadow-[0_0_20px_5px_#204F65]"
              : "bg-gradient-to-r from-[#83329A] to-[#bd9fe6] p-3 inline-block hover:shadow-[0_0_15px_3px_#204F65]"
          }`}
          onClick={handleImageClick}
        >
          <img
            src={'/assets/yana.png'}
            alt="Jessile Bonzo"
            className="rounded-full shadow-lg max-w-full md:max-w-[320px] lg:max-w-md object-cover aspect-square cursor-pointer"
            width={400}
          />
        </div>
      </motion.div>    
      </section>
  );
};

export default Home;
